import css from '../../utils/css';

export const slimBaseStyles = el => {
  const hasZIndexPatch = el.hasAttribute('z-index-patch');
  const zIndexValue = el.getAttribute('z-index-patch');

  const isLiteral = [
    'unset',
    'initial',
    'auto',
    'inherit',
    'revert',
    'revert-layer'
  ];

  const zIndexCss = hasZIndexPatch
    ? `:host {
        position: relative;
        z-index: ${isLiteral.includes(zIndexValue) ? zIndexValue : Number(zIndexValue ?? 1)};
      }`
    : '';

  return css`
    ${zIndexCss}
  `;
};
